import script from "./CooperationRequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CooperationRequestsTable.vue?vue&type=script&setup=true&lang=js"

import "./CooperationRequestsTable.vue?vue&type=style&index=0&id=15b847e4&scoped=true&lang=css"

import exportComponent from "D:\\repository\\vue\\yadino-marketplace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b847e4"]])

export default __exports__